<template>
  <modal name="cookie-popup" height="auto" :adaptive="true">
    <div class="app-modal">
      <div class="d-flex justify-content-center">
        <div class="d-flex flex-row align-items-center mb-2">
          <Logo/>
          <h1 class="ml-2 mb-0">Cookies on AFTV</h1>
        </div>
      </div>
      <div class="d-flex flex-column">
        <h2 class="text-left mt-2 ml-2 mr-2">
          We use cookies to help us to deliver this service and to provide personalised ads.
        </h2>
        <h2 class="text-left ml-2 mr-2">To find out more, check out our
          <a :href="termsLink" target="_blank">privacy policy</a> and
          <a :href="consentLink" target="_blank">cookie policy</a>.
        </h2>
        <h2 class="text-left mb-4 ml-2 mr-2">
          To update your preferences later, select <i>Privacy</i> from the menu.
        </h2>
      </div>
      <div class="d-flex flex-column">
        <button class="primary" v-on:click="onCookieAcceptAll">Accept all cookies</button>
        <button class="secondary" v-on:click="onCookieMoreOptions">More options</button>
      </div>
    </div>
  </modal>
</template>

<script>
import Logo from '../components/Logo.vue'
import { spinnakerApi } from '../js/SpinnakerApi.js'
import { DataConsentUtils } from '../js/DataConsentUtils.js'

const dataConsentUtils = new DataConsentUtils(spinnakerApi)

export default {
  components: {
    Logo
  },
  name: 'dialogue',
  data: function () {
    return {
      accountSummary: null,
      consentInfo: null,
      termsLink: null,
      consentLink: null
    }
  },
  mounted () {
    this.$store.subscribe(async function (mutation, state) {
      switch (mutation.type) {
        case 'showCookiePopup':
          this.accountSummary = await spinnakerApi.fetchAccountSummary()
          this.consentInfo = await dataConsentUtils.fetchDataConsentInfo(this.accountSummary)
          this.termsLink = this.consentInfo.termsLink
          this.consentLink = this.consentInfo.consentLink

          this.$modal.show('cookie-popup')
          this.title = this.$store.state.dialogueTitle
          this.subtitle = this.$store.state.dialogueSubtitle
          break
      }
    }.bind(this))
  },
  methods: {
    async onCookieAcceptAll () {
      this.$modal.hide('cookie-popup')

      try {
        let consentChoices = {}
        for (const option of this.consentInfo.consentOptions) {
          consentChoices[option.key] = true
        }
        await dataConsentUtils.recordChoices(
          this.accountSummary,
          this.consentInfo.termsVersion,
          this.consentInfo.consentVersion,
          consentChoices)
      } catch (err) {
        this.$store.commit('showConnectivityNotice')
        console.info(`Failed to accept all cookies: ${err}`)
      }
      this.$store.commit('hideLoading')
    },
    onCookieMoreOptions () {
      this.$modal.hide('cookie-popup')
      this.$router.replace({ name: 'appInfo' })
    }
  }
}
</script>

<style scoped></style>
